import { categories } from '@/mocks/comics';
import SectionHeader from './SectionHeader';

interface CategoriesProps {
  onSelect: (term: string) => void;
}

export default function Categories({ onSelect }: CategoriesProps) {
  return (
    <section id="categories" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <SectionHeader
          kicker="题材分类"
          title="按口味选漫，题材分类齐全"
          desc="恋爱、奇幻、校园、悬疑、完结、新作六大分类，海量高清韩国漫画任你挑选，每一类都有镇站之作。"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((c) => (
            <button
              key={c.name}
              type="button"
              onClick={() => onSelect(c.name)}
              className="group flex items-center gap-4 p-5 md:p-6 rounded-2xl bg-background-100 border border-background-200 text-left hover:border-primary-300 hover:bg-background-50 transition-colors cursor-pointer"
            >
              <span className={`w-14 h-14 md:w-16 md:h-16 shrink-0 flex items-center justify-center rounded-2xl ${c.color}`}>
                <i className={`${c.icon} text-2xl w-6 h-6 flex items-center justify-center`} />
              </span>
              <span className="min-w-0">
                <span className="flex items-center gap-2">
                  <span className="font-heading text-lg md:text-xl text-foreground-950">{c.name}</span>
                  <span className="text-xs text-foreground-400">{c.en}</span>
                </span>
                <span className="mt-1 block text-sm text-foreground-600 truncate">{c.desc}</span>
                <span className="mt-1.5 inline-flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:text-primary-700">
                  {c.count} 部作品
                  <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center transition-transform group-hover:translate-x-0.5" />
                </span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}